import { LoanDto } from '../../../models/dtos/loan.dto';
import { LoanDetailDto } from '../../../models/dtos/loan-detail.dto';
import { now, oneWeekInMs, oneMonthInMs, oneYearInMs } from '../../utils/time.utils';
import { mockRecurringPayment } from '../payments/recurring-payment-details.dto.mock';

/**
 * Loan DTOs (as they come from the API) for testing
 */

export const MOCK_LOAN_HOME_ID = '1001';
export const MOCK_LOAN_CAR_ID = '1002';

export const mockLoanDtos: Record<string, LoanDto[]> = {
  [MOCK_LOAN_HOME_ID]: [
    {
      acctrefno: MOCK_LOAN_HOME_ID,
      loan_number: MOCK_LOAN_HOME_ID,
      shortname: 'Home Loan',
      current_payoff_balance: '250000.00',
      total_past_due_balance: '0.00',
      last_billing_date: new Date(now - oneMonthInMs * 2).toISOString(),
      next_recurring_trans_date: new Date(now + oneWeekInMs * 2).toISOString(),
      next_billing_date: new Date(now + oneWeekInMs * 2).toISOString(),
      open_date: new Date(now - oneYearInMs * 5).toISOString(),
      status_code_no: 1
    }
  ],
  [MOCK_LOAN_CAR_ID]: [
    {
      acctrefno: MOCK_LOAN_CAR_ID,
      loan_number: MOCK_LOAN_CAR_ID,
      shortname: 'Car Loan',
      current_payoff_balance: '15000.00',
      total_past_due_balance: '500.00',
      last_billing_date: new Date(now - oneMonthInMs).toISOString(),
      next_recurring_trans_date: null,
      next_billing_date: new Date(now + oneWeekInMs * 3).toISOString(),
      open_date: new Date(now - oneYearInMs * 2).toISOString(),
      status_code_no: 1
    }
  ]
};

export const mockLoanDetailDtos: Record<string, LoanDetailDto> = {
  [MOCK_LOAN_HOME_ID]: {
    loan_number: MOCK_LOAN_HOME_ID,
    shortname: 'Home Loan',
    open_date: new Date(now - oneYearInMs * 5).toISOString(),
    curr_maturity_date: new Date(now + oneYearInMs * 20).toISOString(),
    original_note_amount: '300000.00',
    current_principal_balance: '245000.00',
    current_interest_balance: '2500.00',
    current_fees_balance: '150.00',
    current_late_charge_balance: '0.00',
    current_udf1_balance: '100.00',
    current_udf2_balance: '50.00',
    current_payoff_balance: '250000.00',
    current_suspense: '0.00',
    last_payment_amount: '1200.00',
    last_payment_date: new Date(now - oneMonthInMs * 2).toISOString(),
    current_interest_rate: '0.035',
    interest_paid_ytd: '8500.00',
    next_statement1_date: new Date(now + oneWeekInMs * 2).toISOString(),
    next_recurring_trans_date: new Date(now + oneWeekInMs * 2).toISOString(),
    next_billing_date: new Date(now + oneWeekInMs * 2).toISOString(),
    has_recurring_payment: true,
    recurring_disabled: false,
    disable_card_payment: false,
    disable_bank_payment: false,
    disable_card_recurring: false,
    disable_bank_recurring: false,
    total_current_due_balance: '1200.00',
    last_billing_date: new Date(now - oneMonthInMs * 2).toISOString(),
    paymentSettings: {
      recurringPaymentExists: true,
    },
    recurringPayment: mockRecurringPayment,
  },
  [MOCK_LOAN_CAR_ID]: {
    loan_number: MOCK_LOAN_CAR_ID,
    shortname: 'Car Loan',
    open_date: new Date(now - oneYearInMs * 2).toISOString(),
    curr_maturity_date: new Date(now + oneYearInMs * 3).toISOString(),
    original_note_amount: '25000.00',
    current_principal_balance: '14500.00',
    current_interest_balance: '250.00',
    current_fees_balance: '50.00',
    current_late_charge_balance: '200.00',
    current_udf1_balance: '0.00',
    current_udf2_balance: '0.00',
    current_payoff_balance: '15000.00',
    current_suspense: '0.00',
    last_payment_amount: '450.00',
    last_payment_date: new Date(now - oneMonthInMs * 2).toISOString(),
    current_interest_rate: '0.058',
    interest_paid_ytd: '2100.00',
    next_statement1_date: null,
    next_recurring_trans_date: null,
    next_billing_date: new Date(now + oneWeekInMs * 3).toISOString(),
    has_recurring_payment: false,
    recurring_disabled: false,
    disable_card_payment: false,
    disable_bank_payment: false,
    disable_card_recurring: true,
    disable_bank_recurring: false,
    total_current_due_balance: '450.00',
    last_billing_date: new Date(now - oneMonthInMs * 2).toISOString(),
    paymentSettings: {
      recurringPaymentExists: false,
    },
    recurringPayment: null,
  },
};
